/**
 * @file
 * Provide methods for collapsing child elements.
 *
 * The trigger-element get the class 'js-collapse-child-items-trigger' and a data-target
 * attribute, which contains the data-target-id. The data-target-id is defined
 * as attribute on the element which contains the child-elements that should be collapsed.
 *
 * With a data-initial-visible attribute on the container of the child-elements the
 * amount of the initial visible children can be configured.
 *
 * e.g. trigger-element
 * <span class="js-collapse-trigger" data-target="collapse">Ausklappen</span>
 *
 * e.g. container of child elements
 * <div data-target-id="collapse" data-initial-visible="3">Lorem ipsum dolor sit amet</div>
 */

(function ($, Drupal) {
  Drupal.behaviors.collapseChildItems = {
    attach: function attach(context) {

      function hideChildItems($this) {
        const $initialVisibleItems = $this.data('initial-visible');

        $this.children().each(function( index ) {
          const $index = index + 1
          if ($index > $initialVisibleItems) {
            $(this).addClass('is-hidden-collapse-child');
          }
        });
      }

      once('awInitiateToggleChildItem', '.js-collapse-child-items', context).forEach(function(currentElement) {
        hideChildItems($(currentElement));
      });

      once('awShowChildItem', '.js-collapse-child-items-trigger-show', context).forEach(function (currentElement) {
        currentElement.addEventListener('click', function(event) {
          const $trigger = $(this);
          const $triggerSibling = $trigger.siblings('.button');
          const $targetSelector = $trigger.data('target');
          const $target = $('[data-target-id="'+ $targetSelector +'"]');

          $trigger.addClass('is-hidden-collapse-child-items-trigger');
          $triggerSibling.removeClass('is-hidden-collapse-child-items-trigger');

          $target.children().removeClass('is-hidden-collapse-child');
          event.preventDefault();
        });
      });

      once('awSHideChildItem', '.js-collapse-child-items-trigger-hide', context).forEach(function (currentElement) {
        currentElement.addEventListener('click', function(event) {
          const $trigger = $(this);
          const $triggerSibling = $trigger.siblings('.button');
          const $targetSelector = $trigger.data('target');
          const $target = $('[data-target-id="'+ $targetSelector +'"]');

          $trigger.addClass('is-hidden-collapse-child-items-trigger');
          $triggerSibling.removeClass('is-hidden-collapse-child-items-trigger');

          hideChildItems($target);
          event.preventDefault();
        });
      });

    }
  };
})(jQuery, Drupal);
